<template>
  <div>
    <div class="row">
      <div class="col-6">
        <label><b>{{ dateFromLabel }}</b></label>
        <input class="form-control" type="date" v-model="date_from" />
      </div>
      <div class="col-6">
        <label><b>{{ dateToLabel }}</b></label>
        <input class="form-control" type="date" v-model="date_to" />
      </div>
    </div>

    <br />

    <div class="flaot-right text-right">
      <button 
        class="btn btn-rounded btn-primary mr-1" 
        style="width: 150px" 
        @click="handleSubmit">
        Submit
      </button>
      <button 
        type="button" 
        class="btn btn-rounded btn-primary" 
        style="width: 150px" 
        @click="handleReset">
        Reset
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterDate: {
      type: Function,
      required: true
    },

    dateFromLabel: {
      type: String,
      default: "Date From"
    },
    dateToLabel: {
      type: String,
      default: "Date To"
    }
  },
  data() {
    return {
      date_from: '',
      date_to: ''
    };
  },
  methods: {
    handleSubmit() {
      this.filterDate(this.date_from, this.date_to);
    },

    handleReset() {
      this.date_from = '';
      this.date_to = '';
      this.$emit('resetData');
    }
  }
};
</script>

<style scoped>
/* Add styles specific to the DateFilter component */
</style>
